import { BaseText, EBaseTextPosition, EBaseTextSize } from '@spinwise/react-component-library/BaseText';
import Link from 'Components/shared/Link/Link';
import { IconLibrary } from 'Libraries/icons.library';
import { EBrandTextColor } from 'Libraries/typography.library';
import { IconVariantsLibrary } from 'Libraries/variants.library';
import BrandIcon, { BrandIconsSizes, StatusIcons } from '../../../BrandIcon/BrandIcon';

import styles from './ActionCardSmall.module.scss';
import { ButtonIconOnly } from '@spinwise/react-component-library/ButtonIconOnly';
import { EBaseButtonSize, EBaseButtonType } from '@spinwise/react-component-library/ButtonAbstract';

export interface IActionCardSmall {
  id: string;
  title: string;
  subtitle: string;
  link: string;
  returnLink?: string;
  imgUrl: any;
  iconName?: string;
  iconColor?: string;
}
const ActionCardSmall = ({ id, title, subtitle, link, returnLink, imgUrl, iconColor }: IActionCardSmall) => {
  return (
    <Link href={link} className={`d-fl jc-fs ai-c w-100 ${styles.white_block}`}>
      <div className={`d-fl jc-c ai-c ${styles.leftSide}`}>
        <BrandIcon
          iconPath={imgUrl}
          iconSize={BrandIconsSizes.Small}
          shapeColor={iconColor}
          statusPath={StatusIcons.None}
        />
      </div>
      <div className={`d-fl jc-sb ${styles.rightSide}`}>
        <div className={`d-fl jc-c fl-d-c ${styles.title_wrapper}`}>
          <BaseText
            value={title}
            size={EBaseTextSize.Regular}
            color={EBrandTextColor.Black}
            alignment={EBaseTextPosition.Left}
          ></BaseText>
          <BaseText
            value={subtitle}
            size={EBaseTextSize.Small}
            color={EBrandTextColor.Subtitle}
            alignment={EBaseTextPosition.Left}
          ></BaseText>
        </div>
        <div className={`d-fl jc-c ${styles.icon_wrapper}`}>
          <ButtonIconOnly
            iconName={IconLibrary.ArrowRight}
            type={EBaseButtonType.None}
            variant={IconVariantsLibrary.Basic}
            size={EBaseButtonSize.Small}
          />
        </div>
      </div>
    </Link>
  );
};
export default ActionCardSmall;
